import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="text-center text-lg-start mt-5" style={{ borderTop: '2px solid #000' }} >
      <div className="container p-4">
        <img
          src={`${process.env.PUBLIC_URL}/ReddBarna_Logo_Norwegian_Horiz_BlackPos_RGB.png`}
          alt="Redd Barna logo"
          className="img-fluid mb-3 mx-auto d-block"
          style={{ width: 'clamp(100px, 10vw, 200px)', height: 'auto' }}
          loading="lazy"
          decoding="async"
        />
        <p className="text-center">© {new Date().getFullYear()} Perler med Vilje v{process.env.REACT_APP_VERSION ?? 'dev'}.</p>
      </div>
    </footer>
  );
};

export default Footer;